document.documentElement.classList.remove('no-js');

function initialiseApax(root = document) {
  root.querySelectorAll('[data-nav-toggle]').forEach((toggle) => {
    if (toggle.dataset.initialised) return;
    toggle.dataset.initialised = 'true';
    const target = document.getElementById(toggle.getAttribute('data-nav-toggle'));
    if (!target) return;
    const close = () => { target.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); };
    toggle.addEventListener('click', () => {
      toggle.setAttribute('aria-expanded', String(target.classList.toggle('is-open')));
    });
    target.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));
    target.addEventListener('keydown', (event) => { if (event.key === 'Escape') { close(); toggle.focus(); } });
  });
  root.querySelectorAll('[data-variant-selector]').forEach((select) => {
    if (select.dataset.initialised) return;
    select.dataset.initialised = 'true';
    const summary = select.closest('[data-product-summary]');
    const update = () => {
      const option = select.selectedOptions[0];
      if (!option || !summary) return;
      const available = option.dataset.available === 'true';
      summary.querySelector('[data-variant-price]').textContent = option.dataset.price;
      const button = summary.querySelector('[data-add-to-cart]');
      button.disabled = !available;
      button.textContent = available ? 'Add to cart' : 'Sold out';
    };
    select.addEventListener('change', update);
    update();
  });
  const result = root.querySelector('[data-form-result]');
  if (result) result.focus();
}
document.addEventListener('DOMContentLoaded', () => initialiseApax());
document.addEventListener('shopify:section:load', (event) => initialiseApax(event.target));
